import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { TipoHabitacionHotel } from '../../../models/tipo-habitacion-hotel';
import { SessionService } from '../../../services/session.service';
import { TipoHabitacionHotelService } from '../../../services/tipo-habitacion-hotel.service';

@Component({
  selector: 'app-tipo-habitacion-hotel-edit-modal',
  templateUrl: './tipo-habitacion-hotel-edit-modal.component.html',
  styleUrls: ['./tipo-habitacion-hotel-edit-modal.component.css'],
  providers: [
    TipoHabitacionHotelService,
  ],
})

export class TipoHabitacionHotelEditModalComponent implements OnInit {
	@Input() tipo_habitacion_hotel_id: String;
	@Output() sendTipoHabitacion = new EventEmitter();
	public title: String;
	public tipoHabitacion: TipoHabitacionHotel;
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public loading = false;

	constructor(
		public bsModalRef: BsModalRef,
		private tipoHabitacionHotelService: TipoHabitacionHotelService,
		private storage: AsyncLocalStorage,
		private ss: SessionService,
		public fb: FormBuilder,
	) {
		this.title = "Guardar";

	}

	ngOnInit() {
		
		//Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Banco
		this.tipoHabitacion = new TipoHabitacionHotel();
		
		this.getTipoHabitacionById();
	}

	getTipoHabitacionById(){    
		return new Promise ( (resolve, reject) => {
		this.tipoHabitacionHotelService.getById(this.tipo_habitacion_hotel_id).subscribe(
			res => {
			
			this.tipoHabitacion = res;
			this.setValueForm();
			resolve();
			},
			err => {
			reject();
			}
		);
		});   
	}



  	onForm() {
		this.myForm = this.fb.group({
			nombre: ['', [Validators.required,
			Validators.pattern(/[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]*/)]],
		});
	}

	setValueForm() {
		this.myForm.setValue({
			nombre: this.tipoHabitacion.nombre
		});
	}
	setValueEntity(){
		this.tipoHabitacion.nombre = this.myForm.controls['nombre'].value;
		this.tipoHabitacion.usuario_id = this.ss.getData('usuario_id');
	}

	validErrorForm(campo){
		return this.vl.validErrorForm(campo,this.myForm);
	}

	validTypeMsgForm(nombre,campo){
		return this.vl.validTypeMsgForm(nombre,campo,this.myForm);
  	}
  
	onSubmit(){
		this.setValueEntity();
		this.msg.showMessage('delete-confirm-message', "¿Está seguro de confirmar la modificación?").then(
			res => {
				this.loading = true;
				this.tipoHabitacionHotelService.update(this.tipoHabitacion).subscribe(
					res => {
						this.msg.showMessage('success-message', 'Se ha procesado correctamente' );
						this.sendTipoHabitacion.emit(res.data);
						this.loading = false;
					},
					err => { 
						this.loading = false;
						this.msg.showMessage('error-message', err);
					}
				);
			}
		);
	}


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/tipo-habitacion-hotel-edit-modal/tipo-habitacion-hotel-edit-modal.component.ts